import i18next from 'i18next';

i18next.addResources('es_CL', 'LoyaltyBenefits', {
  dontLosePoints: '¡No pierdas tus puntos!',
  gotBenefits: 'Tienes estos beneficios',
  keepGrowing: 'Sigue subiendo de nivel',
  nextBenefits: 'Próximos beneficios',
  goToBuy: 'Ir a comprar'
});

i18next.addResources('es_ES', 'LoyaltyBenefits', {
  dontLosePoints: '¡No dejes escapar tus Papa Puntos!'
});
